import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fr from "./locales/fr.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import zh from "./locales/zh.json";
import ru from "./locales/ru.json";
import pt from "./locales/pt.json";

export const SUPPORTED_LANGS = ["fr", "en", "es", "zh", "ru", "pt"];

export const LANG_LABELS = {
  fr: "Français",
  en: "English",
  es: "Español",
  zh: "中文",
  ru: "Русский",
  pt: "Português",
};

i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr },
    en: { translation: en },
    es: { translation: es },
    zh: { translation: zh },
    ru: { translation: ru },
    pt: { translation: pt },
  },
  lng: "fr",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  returnObjects: true,
});

export function detectDefaultLang() {
  const stored = localStorage.getItem("fastority_lang");
  if (stored && SUPPORTED_LANGS.includes(stored)) return stored;
  const nav = navigator.language?.split("-")[0];
  if (nav && SUPPORTED_LANGS.includes(nav)) return nav;
  return "fr";
}

export default i18n;
